import type {
  DeleteApiTracksIdPathParams,
  PutApiTracksIdMutationRequest,
  TrackModel,
  UpdateTrackModel,
} from '@/shared/api'
import { STRINGS } from '@/shared/config'
import { showNotificationSuccessFx } from '@/shared/lib/providers'
import { createEvent, sample } from 'effector'

import {
  type DeleteApiTracksParams,
  type DeleteApiTracksParamsParams,
  jingleByIdQuery,
  jingleCreate,
  jingleDelete,
  jingleUpdate,
  trackMultipleDelete,
} from '../api'

// Create

export const jingleSubmitted = createEvent<UpdateTrackModel>()
sample({
  source: jingleByIdQuery.$status,
  clock: jingleSubmitted,
  filter: (jingleByIdQueryStatus) => jingleByIdQueryStatus === 'initial',
  fn: (
    _,
    formData,
  ): {
    data: PutApiTracksIdMutationRequest
  } => {
    return {
      data: formData,
    }
  },
  target: jingleCreate.start,
})

sample({
  source: jingleByIdQuery.$data,
  clock: jingleCreate.finished.success,

  fn: () => ({ message: STRINGS.success_creation }),
  target: showNotificationSuccessFx,
})

// Edit

sample({
  source: jingleByIdQuery.$data,
  clock: jingleSubmitted,
  filter: (track: TrackModel | null): track is TrackModel => {
    return track !== null && typeof track.id === 'string'
  },
  fn: (jingle, formData) => {
    return { id: jingle.id, data: formData }
  },
  target: jingleUpdate.start,
})

sample({
  clock: jingleUpdate.finished.success,
  fn: () => ({ message: STRINGS.success_update }),
  target: showNotificationSuccessFx,
})
// Delete

export const jingleDeleted = createEvent<{
  id: DeleteApiTracksIdPathParams['Id']
}>()

sample({
  clock: jingleDeleted,
  fn: ({ id }) => ({ id }),
  target: [jingleDelete.start],
})

sample({
  clock: jingleDelete.finished.success,
  fn: () => ({ message: STRINGS.success_deletion }),
  target: showNotificationSuccessFx,
})

// Delete Multiple

export const selectedJinglesDeleted = createEvent<{
  trackIds: DeleteApiTracksParamsParams['TrackIds']
}>()

sample({
  clock: selectedJinglesDeleted,
  fn: ({ trackIds: TrackIds }): DeleteApiTracksParams => ({
    params: { TrackIds },
  }),
  target: trackMultipleDelete.start,
})
